module.exports = __webpack_public_path__ + "assets/loop-edit-active.010d8534.svg";